module.exports = __webpack_public_path__ + "media/members/import_golfers-05ba2d7b.png";